import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { TvNavigationService } from '../../services/tv-navigation.service';

@Directive({
  selector: '[appTvFocusable]'
})
export class TvFocusableDirective implements OnInit, OnDestroy {
  // Optional: override ID or group (future proofing)
  @Input() tvId : string | null = null;
  
  private registrationId: string | null = null;

  constructor(
    private el: ElementRef, 
    private tvNav: TvNavigationService
  ) {}

  ngOnInit() {
    this.el.nativeElement.setAttribute('tabindex', '-1'); // Ensure focusable programmatically but not by Tab key if desired
    this.registrationId = this.tvNav.register(this.el.nativeElement);
  }

  ngOnDestroy() {
    if (this.registrationId) {
      this.tvNav.unregister(this.registrationId);
    }
  }
}
